import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomLabel from '@s-ui/react-atom-label'
import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

import {LABEL_CLASS_NAME} from '../../config.js'

const FilterBasicLabelVisible = ({htmlFor, label, description, nodeLabel}) => (
  <div className={LABEL_CLASS_NAME}>
    <AtomLabel htmlFor={htmlFor} text={label} />
    {Boolean(nodeLabel) && nodeLabel}
    {description && (
      <AtomTooltip placement={AtomTooltipPlacements.AUTO} content={description}>
        <div>
          <IconInfoOutline aria-hidden role="presentation" size={atomIconSizes.medium} />
        </div>
      </AtomTooltip>
    )}
  </div>
)

FilterBasicLabelVisible.displayName = 'FilterBasicLabelVisible'
FilterBasicLabelVisible.propTypes = {
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  nodeLabel: PropTypes.node
}

export default FilterBasicLabelVisible
